var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"documentation-container"},[_c('Header',{ref:"Headers"}),_c('CategoryView',{ref:"categoryView",attrs:{"categoryId":"503"}}),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }